/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopOrderDto } from '../../models/shop-order-dto';

export interface ShopUpdateOrder$Params {
  'x-trace-id'?: string;
  id: string;
      body: ShopOrderDto
}

export function shopUpdateOrder(http: HttpClient, rootUrl: string, params: ShopUpdateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopOrderDto>> {
  const rb = new RequestBuilder(rootUrl, shopUpdateOrder.PATH, 'put');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopOrderDto>;
    })
  );
}

shopUpdateOrder.PATH = '/api/shop/order/{id}';
